import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'

@inject('localizationStore')

@observer
export default class ServerError extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        let ls = this.props.localizationStore!

        return (
            <div>
                <h3>{ls.t!('Server error page')}</h3>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ServerError.tsx